import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import Slider from "react-infinite-logo-slider";
import { ApiLinkContext } from "../../context/ApiLinkContext";
import { NavLink } from "react-router-dom";
import slugify from "react-slugify";
import translations from "../../data/langData";
import {LanguageContext} from "../../context/LanguageContext" ;
const ProjectsSlider = () => {
  const { loading, projects, error } = useContext(ApiLinkContext);
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  return (
    <>
      <div style={{ marginTop: "100px", marginBottom: "100px" }}>
        <h2 className="title text-center py-3" style={{textTransform:"uppercase"}}>{t.successprojects}</h2>
        <Slider
          // width="120px"
          duration={50}
          pauseOnHover={true}
          blurBorders={true}
          blurBorderColor={"#fff"}
        >
          {projects.map((item) => {
            return (
              <NavLink
                className="mx-4"
                style={{
                  height: "100px",
                  display: "block",
                  overflow: "hidden",
                }}
                to={`/projects/${slugify(
                  `${item.id}-${item.name}`
                ).toLowerCase()}`}
              >
                <img
                  src={item.ico}
                  alt=""
                  className="img-fluid"
                  style={{
                    cursor: "pointer",
                    objectFit: "contain",
                    width: "100%",
                    height: "100%",
                  }}
                />
              </NavLink>
            );
          })}
        </Slider>
      </div>

      <div className="parallax">
        <div className="outline"></div>
      </div>
    </>
  );
};

export default ProjectsSlider;
